function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M500,0C223.9,0,0,223.9,0,500s223.9,500,500,500s500-223.9,500-500S776.1,0,500,0z M438.4,169h125.9v257.4 c0,27.6-1.6,55.1-4.8,82.4c-3.2,27-7.4,54.6-12.6,82.8h-91.1c-5.2-28.2-9.4-55.8-12.6-82.8c-3.2-27.3-4.8-54.8-4.8-82.4V169z  M570.3,784.7c-3.8,9.3-9.1,17.4-16.1,24.3c-6.9,6.9-15,12.3-24.3,16.2c-9.3,3.9-19.2,5.9-29.9,5.9c-11,0-21.1-1.9-30.4-5.9 c-9.3-3.9-17.4-9.3-24.3-16.2c-6.7-6.9-12-15-16.1-24.3c-3.8-9.6-5.6-19.8-5.6-30.6s1.9-20.9,5.6-30.2c4.1-9.3,9.4-17.4,16.1-24.3 c6.9-6.9,15-12.3,24.3-16.2c9.3-4.2,19.4-6.3,30.4-6.3c10.7,0,20.7,2.1,29.9,6.3c9.3,3.9,17.4,9.3,24.3,16.2 c6.9,6.9,12.3,15,16.1,24.3c4.1,9.3,6.1,19.4,6.1,30.2S574.4,775.1,570.3,784.7z"
});

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-alert",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.220b879b.svg";
export { ForwardRef as ReactComponent };